import { IsString, IsNotEmpty, IsUUID, IsEnum } from 'class-validator';
import { UserEmailPreferencesTypeEnum } from '../../enums';

export class UnsubscribeUserFromNewsletterDto {
	@IsUUID()
	@IsNotEmpty({ message: 'User is required' })
	public userId: string;

	@IsUUID()
	@IsNotEmpty({ message: 'Community is required' })
	public hostId: string;

	@IsEnum(UserEmailPreferencesTypeEnum)
	public emailType: UserEmailPreferencesTypeEnum;

	@IsString()
	public reason?: string;

	public createdAt?: Date;
}
